import { useFloatingContext } from 'library/floating';
import { List } from 'library/list';
import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface DropdownListProps extends DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement> {
    children: ReactNode;
}

const DropdownList: FC<DropdownListProps> = (props) => {
    const { children, className, style, ...rest } = props;

    const { context, refs, getFloatingProps } = useFloatingContext();

    return (
        <>
            {context.open && (
                <List
                    {...rest}
                    {...getFloatingProps()}
                    ref={refs.setFloating}
                    className={twMerge('z-10', className)}
                    style={{ ...context.floatingStyles, ...style }}
                >
                    {children}
                </List>
            )}
        </>
    );
};

export default DropdownList;
